module.exports = __webpack_public_path__ + "static/assets/f0b24a800adcdf60f9198d4aaa804151.svg";